import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useQuery } from 'react-query'
import { isEmpty } from 'lodash';
import { getEditTypes, cancelationReasons, cancelationRequestor, getStatelist, withdrawalReasons } from '../api';
import { getEditedData } from '../components/ManageRequest/EditRequest/helpers';

const EditRequestContext = createContext();
const { Consumer: UserConsumer, Provider } = EditRequestContext;

export function EditRequestProvider({ children, testState, data }) {
  const reasonsData = useQuery('CancelationReasons', () => cancelationReasons(), { refetchOnWindowFocus: false });
  const withdrawalReasonData = useQuery('WithdrawalReasons', () => withdrawalReasons(), { refetchOnWindowFocus: false });
  const requestorData = useQuery('CancelationRequestor', () => cancelationRequestor(), { refetchOnWindowFocus: false });
  const stateList = useQuery('stateList', () => getStatelist(), { refetchOnWindowFocus: false });

  const [editTypesList, setEditTypes] = useState({ isLoading: true, data: [] });
  const [requestData, setRequestData] = useState({});
  const [editCases, setEditCases] = useState([{}]);
  const [isTest, setIsTest] = useState(testState);
  if (isTest) {
    setIsTest(false);
    setRequestData(data);
  }
  const { requestStatus, serviceLineStatus, lastLine, initialRequest } = requestData;

  useEffect(() => {
    getEditTypes({ status: requestStatus, serviceLineStatus, lastLine, initialRequest }).then(data => {
      setEditTypes({ isLoading: false, data })
    });

    setEditCases([{}]);
  }, [requestData]);

  const initialData = useMemo(() => {
    if (isEmpty(requestData)) return {};

    const {
      reviewType,
      approvedStartDate,
      requestedStartDate,
      approvedEndDate,
      requestedEndDate,
      units,
      requestedUnits,
      metadata
    } = requestData?.request?.[0];

    return {
      ...requestData.request?.[0],
      lastLine,
      isRetrospective: reviewType === 'Retrospective',
      startDate: approvedStartDate || requestedStartDate,
      endDate: approvedEndDate || requestedEndDate,
      units: units === null ? units : Number(units || requestedUnits),
      isSingleLine: requestData.isSingleLine,
      metadata
    };
  }, [requestData]);

  const currentData = useMemo(() => {
    const editedData = getEditedData(initialData, editCases, setEditCases);
    return editedData ? { ...initialData, ...editedData } : initialData;
  }, [initialData, editCases]);

  return (
    <Provider
      value={{
        requestData,
        setRequestData,
        initialData,
        currentData,
        editCases,
        setEditCases,
        setEditTypes,
        editTypesList,
        reasonsData,
        requestorData,
        stateList,
        withdrawalReasonData
      }}
    >
      {children}
    </Provider>
  );
}
export default EditRequestProvider;

export const useEditRequestContext = () => {
  const context = useContext(EditRequestContext);
  return { ...context };
};
